import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IController, IModule, IPromise, IQService, IScope} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import moment from "moment";
import _ from "lodash";
import {IntroJsTjeneste} from "felles/tjenester/IntroJs";
import {InnlastingsindikatorKontroller} from "../../../basis/direktiver/innlastingsindikator";
import {GruppeRessurs} from "felles/tjenester/ressurser/GruppeRessurs";
import {Debugger} from "debug";
import {MalmøteRessurs} from "felles/tjenester/ressurser/MalmøteRessurs";
import {UuidGenerator} from "felles/tjenester/UuidGenerator";
import {Møtevalideringsfeil, NyttMøteSkjemaModell} from "../../../møte/MøteTjeneste";
import {NyttMøteIOpprettPlanDialog} from "../../../møte/modale/nyttMøteIOpprettPlanDialog/nyttMøteIOpprettPlanDialog";
import {MøteRessurs} from "../../../../../felles/tjenester/ressurser/MøteRessurs";
import {PlanRessurs} from "../../../../../felles/tjenester/ressurser/PlanRessurs";

require('twix'); //utvider moment

const debug: Debugger = require('debug')('PlanerKontroller');
const css = require('./opprettplan.scss');

export class OpprettPlanSkjemaKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmOpprettPlan', {
                bindings: {gruppeId: '<', kopierPlan: '<?', periode: '<', vedSpesifikasjonOppdatert: '&'},
                controller: OpprettPlanSkjemaKontroller.forInjisering(),
                template: require('./opprettplan.html')
            })
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.ng.$q,
            regNavn.md.$mdDialog,
            IntroJsTjeneste.regNavn,
            GruppeRessurs.regNavn,
            PlanRessurs.regNavn,
            MøteRessurs.regNavn,
            MalmøteRessurs.regNavn,
            UuidGenerator.regNavn,
            OpprettPlanSkjemaKontroller
        ]
    }

    constructor(private $scope: IScope,
                private $q: IQService,
                private $mdDialog: angular.material.IDialogService,
                private introJs: IntroJsTjeneste,
                private gruppeRes: GruppeRessurs,
                private planRessurs: PlanRessurs,
                private møteRessurs: MøteRessurs,
                private malmøteRessurs: MalmøteRessurs,
                private uuidGenerator: UuidGenerator) {
    }

    gruppeId:string; //settes via bindings/$onChanges
    kopierPlan:l.PlanModell; //settes via bindings/$onChanges
    periode: l.PlanPeriode; //settes via bindings/$onChanges
    vedSpesifikasjonOppdatert: (args: { nyttMoeteSpesifikasjoner: l.NyttMøteSpesifikasjon[], kopierMoeteSpesifikasjoner: l.KopierMøteSpesifikasjon[] }) => void;

    gruppe: l.GruppeModell;
    moeter: NyttMøteSkjemaModell[] = [];
    moeterPerMaaned: MånedInfo[];
    saksgrupperinger: SaksgruppeInfo[];
    bredde: number;
    hoeyde: number;
    laster = false;

    private møtemal: l.MalmøteModell;

    private minMndBredde = 50;
    private møteBredde = 60;
    private møteHøyde = 40; //må holdes i synk med $møte-høyde i css
    private møteHorisontalMargin = 5;
    private sakshøyde = 40;
    private saksVertikalMargin = 5;

    ingenMoeter() {
        return _.isEmpty(this.moeter);
    }

    nyttMoeteIMnd(måned:MånedInfo){
        const dato = moment(måned.mnd);
        const dagerTilNesteMandag = dato.isoWeekday() == 1 ? 0 : 8 - dato.isoWeekday();
        dato.add(dagerTilNesteMandag, 'days').toDate();
        //sørg for at vi ikke oppretter flere møter på samme dag
        while(this.moeter.some(møte => dato.isSame(møte.moetedato.start, 'day')))
            dato.add(1, 'day');
        dato.hours(9); //en fornuftig standardverdi - vil uansett overstyres derom start er satt i møtemal

        if (_.isNil(this.møtemal.varighet)) this.møtemal.varighet = 60; //vi må sette en verdi for at møte skal bli gyldig - eller vil "opprett plan" feile dersom man ikke har ikke har redigert det
        const møte = NyttMøteSkjemaModell.nyNyttMøteSkjemaModellFraMøtemal(dato.toDate(), this.møtemal, this.gruppe, this.uuidGenerator);
        møte.tillattStartdatoPeriode = _.cloneDeep(this.periode); //<md-datepicker md-min/max-date attributtene ser ut til å endre Dato-objektet - derfor clone
        this.moeter.push(møte)
        this.oppdaterModell();
    }

    klikkPaaMoete(møte: MøteInfo) {
        NyttMøteIOpprettPlanDialog.visNyttMøteDialog(
            møte.moete.kopier(),
            møte.moete.kopiAvEksisterendeMøte == null,
            (spesifikasjon: l.NyttMøteSpesifikasjon) => this.validerSpesifikasjon(spesifikasjon), this.$mdDialog)
            .then(respons => {
                _.pull(this.moeter, møte.moete);
                if (!respons.fjernet) this.moeter.push(respons.modell);
                this.oppdaterModell();
            })
            .catch(()=>{}); //ingen ting å gjøre når dialog lukkes
    }

    erSakInkludert(sak:SakInfo){
        return _.includes(sak.moete.moete.spesifikasjon.valgteMalsaker, sak.sak.id);
    }

    togleSakInkludert(sak:SakInfo){
        const valgteMalsaker = sak.moete.moete.spesifikasjon.valgteMalsaker;
        this.erSakInkludert(sak) ?
            _.pull(valgteMalsaker, sak.sak.id) :
            valgteMalsaker.push(sak.sak.id);
        this.nårMøtespesifikasjonerOppdatert();
    }

    $onInit(): void {
        this.oppdaterModell(); //fører til at en tom plan blir tegnet ut
        this.lastData();
    }

    //hjelpemetoder

    private lastData() {
        InnlastingsindikatorKontroller.visIndikator(this.$scope.$root);
        this.laster = true;
        this.gruppeRes.hent(this.gruppeId).$promise
            .then(gruppe => this.gruppe = gruppe)
            .then(() => this.lastMøtemal())
            .then(() => this.populerModellMedPlanMal())
            .finally(() => {
                InnlastingsindikatorKontroller.skjuleIndikator(this.$scope.$root);
                this.laster = false;
            });
    }

    private populerModellMedPlanMal() {
        if (this.kopierPlan == null) return;
        return this.møteRessurs.finnMøterTilhørendeGruppeIPerioden(this.kopierPlan.periode.start, this.kopierPlan.periode.slutt, this.gruppeId).$promise
            .then(møter => {
                møter.forEach(møte => this.leggTilNyttMøte(møte, this.kopierPlan.periode.start));
                this.oppdaterModell();
            });
    }

    private leggTilNyttMøte(malMøte:l.MøteModell, kildePlanStartdato:Date){
        const dagOffset = moment(kildePlanStartdato).twix(this.periode.start).length('days');
        const møtedato = moment(malMøte.dato.start).add(dagOffset, 'days').toDate();
        const møte = NyttMøteSkjemaModell.nyNyttMøteSkjemaModellFraMøte(møtedato, malMøte, this.gruppe, this.uuidGenerator);
        møte.tillattStartdatoPeriode = _.cloneDeep(this.periode); //<md-datepicker md-min/max-date attributtene ser ut til å endre Dato-objektet - derfor clone
        //overstyr med informasjon fra gruppens møtemal
        møte.spesifikasjon.erMoetePublisert = this.møtemal.erMoetePublisert;
        møte.spesifikasjon.erProtokollPublisert = this.møtemal.erProtokollPublisert;
        møte.spesifikasjon.deltakere = this.møtemal.deltakere.map(deltaker => ({medlemId: deltaker.medlem.id, medlemInvitasjon: null, representerteAksjeeiere: null}));
        møte.spesifikasjon.eksterneDeltakere = [];
        this.moeter.push(møte)
    }

    private somTwixPeriode(periode: l.MøteDato){
        return moment(periode.start).twix(periode.slutt);
    }

    private validerSpesifikasjon(spesifikasjon: l.NyttMøteSpesifikasjon): IPromise<Møtevalideringsfeil> {
        if(spesifikasjon.dato.slutt < spesifikasjon.dato.start) {
            // Feil i møtedato, slutt før start - issue #2256
            return this.$q.resolve(Møtevalideringsfeil.sluttFoerStart);
        }

        const nyPeriode = this.somTwixPeriode(spesifikasjon.dato);
        const overlappende = this.moeter.filter(møte => møte.spesifikasjon.id != spesifikasjon.id && nyPeriode.overlaps(this.somTwixPeriode(møte.somNyttMøteSpesifikasjon().dato)));
        return this.$q.resolve(overlappende.length > 0 ? Møtevalideringsfeil.overlappendeMoete : Møtevalideringsfeil.ok);
    }

    private oppdaterModell(){
        const møteInfoer = this.somMøteInfo(this.moeter);
        this.moeterPerMaaned = this.beregnMøterPerMaaned(møteInfoer);
        this.saksgrupperinger =  this.beregnDetaljerForGruppe(møteInfoer)
        this.bredde = _(this.moeterPerMaaned).last().pos.tr;
        this.hoeyde = _(this.saksgrupperinger).map(gruppering => gruppering.pos.hoyde).sum() + this.møteHøyde;

        this.nårMøtespesifikasjonerOppdatert();
    }

    private somMøteInfo(møter: NyttMøteSkjemaModell[]): MøteInfo[] {
        return _(møter)
            .sortBy((møte: NyttMøteSkjemaModell) => møte.moetedato.start)
            .map((møte: NyttMøteSkjemaModell) => new MøteInfo(møte, this.møteBredde, this.sakshøyde))
            .value();
    }

    private beregnMøterPerMaaned(møter: MøteInfo[]): MånedInfo[] {
        return _(møter)
            //grupper møter etter måned
            .groupBy((møter: MøteInfo) => møter.mndTs)
            //sørg for at det finnes en gruppe for hver måned i perioden
            .defaults(this.tommeMåneder())
            //oppdater møteInfo gruppert etter måned med beregnet start og slutt pos
            .mapValues((møteInfos: MøteInfo[]) => {
                møteInfos.forEach((møteInfo: MøteInfo, index: number) => {
                        møteInfo.pos.tl = this.kalkulerMøteTopLeft(møteInfo, index, møteInfos);
                        møteInfo.pos.tr = møteInfo.pos.tl + møteInfo.pos.bredde;
                    });
                return møteInfos
            })
            //for hver måned, lag månedInfo representasjon som inneholder liste med møteInfo representasjoner
            .mapValues((møteInfos: MøteInfo[], mndTs: string) => new MånedInfo(møteInfos, mndTs))
            //til array av månedInfo representasjoner
            .values()
            .sortBy((mndInfo:MånedInfo) => mndInfo.mnd)
            //oppdater månedInfo med beregnet start og slutt pos
            .map((mndInfo: MånedInfo, index: number, mndInfos: MånedInfo[]) => {
                mndInfo.pos.bredde = _.isEmpty(mndInfo.moeterIMnd) ? this.minMndBredde : _(mndInfo.moeterIMnd).last().pos.tr + this.møteHorisontalMargin;
                mndInfo.pos.tl = index == 0 ? 0 : (mndInfos[index - 1].pos.tr);
                mndInfo.pos.tr = mndInfo.pos.tl + mndInfo.pos.bredde;
                //gjør møteInfo pos absolutt
                _(mndInfo.moeterIMnd).each(møteInfo => {
                    møteInfo.pos.tl = mndInfo.pos.tl + møteInfo.pos.tl;
                    møteInfo.pos.tr = mndInfo.pos.tl + møteInfo.pos.tr;
                });
                return mndInfo;
            })
            .value();
    }

    private tommeMåneder() {
        //trekker fra en dag på slutt-dato for å kompansere for at slutt i UTC havner i januar
        return _((<any>moment(this.periode.start).twix(moment(this.periode.slutt).subtract(1, 'day'))).toArray('months'))
            .map(måned => [måned.toDate().getTime(), []])
            .fromPairs()
            .value();
    }

    private kalkulerMøteTopLeft(møteInfo: MøteInfo, index: number, møteInfos: MøteInfo[]) {
        if (index == 0) return this.møteHorisontalMargin;//første møte i måneden
        const forrigeMøte = møteInfos[index - 1];

        //håndter plassering av møter i ulike grupper
        if (forrigeMøte.moete.gruppe.id  != møteInfo.moete.gruppe.id) {
            //dersom samme tidspunkt, vis direkte under
            if (moment(forrigeMøte.moete.moetedato.start).isSame(møteInfo.moete.moetedato.start, 'day'))
                return forrigeMøte.pos.tl;
            //dersom ikke samme tidspunkt, vis forskjøvet
            //@todo: håndter tilfelle: a1, b2, a2 - per i dag blir b2 og a2 vist halvt under a1, skulle vært vist helt etter pga a2
            const forrigeMøteSammeGruppe: MøteInfo = _(møteInfos)
            .slice(0, index)//møteInfos frem  til møteInfo, men ikke inkludert møteInfo
                .reverse()
                .find(m => m.moete.gruppe.id == møteInfo.moete.gruppe.id);
            debug("forrigeMøteSammeGruppe", forrigeMøteSammeGruppe, møteInfos, index)
            return Math.max(
                forrigeMøteSammeGruppe ? forrigeMøteSammeGruppe.pos.tr : 0,
                forrigeMøte.pos.tl + (this.møteBredde / 2)
            ) + this.møteHorisontalMargin;
        }

        return forrigeMøte.pos.tr + this.møteHorisontalMargin * 2;
    }

    private lastMøtemal(): IPromise<any> {
        return this.malmøteRessurs.hent(this.gruppeId).$promise
            .then(mal => this.møtemal = mal);
    }

    private beregnDetaljerForGruppe(møter: MøteInfo[]): SaksgruppeInfo[] {
        debug("beregnDetaljerForGruppe", møter)

        const saksgrupper = _(møter)
            .flatMap((m: MøteInfo) => m.saker) //som array av saker på tvers av møter
            .filter((s:SakInfo) => !s.sak.erPause)
            .groupBy((s:SakInfo) => s.sak.tema ? s.sak.tema.id : 'uten_tema')
            .values()
            .map((saker: SakInfo[])=>{
                const møteInfos: MøteMedSakerInfo[] = <any>_(saker)
                    //gruppert på møte
                    .groupBy((s:SakInfo) => s.moete.moete.spesifikasjon.id)
                    .values() //til liste med MøteInfo[]
                    //lag MøteMedSakerInfo representasjon for hver møte
                    .map((saker: SakInfo[]) => new MøteMedSakerInfo(saker, this.saksVertikalMargin))
                    .value();
                return new SaksgruppeInfo(møteInfos, this.sakshøyde, this.saksVertikalMargin)
            })
            .value();
        return saksgrupper;
    }

    private nyttMøteSpesifikasjoner() {
        return this.moeter
            .filter(møte => møte.kopiAvEksisterendeMøte == null)
            .map(møte => møte.somNyttMøteSpesifikasjon());
    }

    private kopierMøteSpesifikasjoner() {
        return this.moeter
            .filter(møte => møte.kopiAvEksisterendeMøte != null)
            .map(møte => møte.somKopierMøteSpesifikasjon());
    }

    private nårMøtespesifikasjonerOppdatert(){
        this.vedSpesifikasjonOppdatert({nyttMoeteSpesifikasjoner:this.nyttMøteSpesifikasjoner(), kopierMoeteSpesifikasjoner:this.kopierMøteSpesifikasjoner()});
    }

}

class MånedInfo {
    pos: { tl: number; tr: number; bredde: number; };
    mnd: Date;
    moeterIMnd: MøteInfo[];
    visOpprettIkon = false;

    constructor(møteInfos: MøteInfo[], mndTs: string) {
        this.pos = {tl: null, tr: null, bredde: null}; //settes senere
        this.mnd = moment(parseInt(mndTs)).toDate();
        this.moeterIMnd = møteInfos;
    }
}

class MøteInfo {
    moete: NyttMøteSkjemaModell;
    saker: SakInfo[];
    pos: { tl: number; tr: number; bredde: number; };
    mndTs: number;

    constructor(møte: NyttMøteSkjemaModell, møteBredde:number, sakHøyde:number) {
        this.moete = møte;
        this.saker = møte.moetemal.saker.map(sak => new SakInfo(sak, this, sakHøyde));
        this.pos = {tl: null, tr: null, bredde: møteBredde}; //settes senere
        this.mndTs = moment(møte.moetedato.start).startOf('month').toDate().getTime();
    }
}

class SakInfo {
    sak: l.MalsakModell;
    moete: MøteInfo;
    pos: { tl: number; bl: number; hoyde: number };

    constructor(sak: l.MalsakModell, moete: MøteInfo, sakHøyde:number) {
        this.sak = sak;
        this.moete = moete;
        this.pos = { tl: null, bl: null, hoyde: sakHøyde }; //settes senere
    }
}

class SaksgruppeInfo {
    saksgruppe: l.TemaModell;
    maxAntSakerPerMoete: number;
    totAntSaker: number;
    pos: { hoyde: number; };
    moeter: MøteMedSakerInfo[];

    constructor(møter: MøteMedSakerInfo[],  sakshøyde:number, saksVertikalMargin:number) {
        var maxAntSakerPerMoete = _(møter).map((møte:MøteMedSakerInfo) => møte.saker.length).max();
        var totAntSaker = _(møter).map((møte:MøteMedSakerInfo) => møte.saker.length).sum();

        this.saksgruppe = møter[0].saker[0].sak.tema; //null dersom tema ikke satt
        this.maxAntSakerPerMoete = maxAntSakerPerMoete;
        this.totAntSaker = totAntSaker;
        this.pos = {hoyde: (sakshøyde + (saksVertikalMargin * 2)) * maxAntSakerPerMoete};
        this.moeter = møter;
    }
}

class MøteMedSakerInfo {
    moeteInfo: MøteInfo;
    saker: SakInfo[];

    constructor(saker: SakInfo[], saksVertikalMargin: number) {
        this.moeteInfo = saker[0].moete;
        this.saker = saker;
        //oppdater sak.pos
        saker.forEach((sak: SakInfo, index: number) => {
            const tl = index == 0 ? saksVertikalMargin :
                (sak.pos.hoyde * index) + ((saksVertikalMargin * 2) * index) + saksVertikalMargin;
            sak.pos.tl = tl;
            sak.pos.bl = tl + sak.pos.hoyde;
        });
    }
}
